import request from '@/network/http'

export function getTemplateCheckupProjectList(data) {
    return request({
        url: 'Template/CheckupProject/getTemplateCheckupProjectList',
        method: 'post',
        data
    })
}

export function getSelfCheckupSubjectList(data) {
    return request({
        url: 'Template/CheckupProject/getSelfCheckupSubjectList',
        method: 'post',
        data
    })
}

export function getDistributeCheckupSubjectList(data) {
    return request({
        url: 'Template/CheckupProject/getDistributeCheckupSubjectList',
        method: 'post',
        data
    })
}

export function createCheckupProjectInfo(data) {
    return request({
        url: 'Checkup/CheckupProject/createCheckupProjectInfo',
        method: 'post',
        data
    })
}

export function getCheckupProjectTimeList(data) {
    return request({
        url: 'Checkup/CheckupProject/getCheckupProjectTimeList',
        method: 'post',
        data
    })
}

export function getCheckupProjectDetail(data) {
    return request({
        url: 'Checkup/CheckupProject/getCheckupProjectDetail',
        method: 'post',
        data
    })
}

export function getCheckupItemListInSubject(data) {
    return request({
        url: 'Checkup/CheckupSubject/getCheckupItemListInSubject',
        method: 'post',
        data
    })
}

export function getCheckupItemInfoInSubject(data) {
    return request({
        url: 'Checkup/CheckupSubject/getCheckupItemInfoInSubject',
        method: 'post',
        data
    })
}

export function getCheckupProjectUserList(data) {
    return request({
        url: 'Checkup/CheckupProject/getCheckupProjectUserList',
        method: 'post',
        data
    })
}

export function saveCheckupProjectUserInfo(data) {
    return request({
        url: 'Checkup/CheckupProject/saveCheckupProjectUserInfo',
        method: 'post',
        data
    })
}

export function deleteCheckupProjectUserInfo(data) {
    return request({
        url: 'Checkup/CheckupProject/deleteCheckupProjectUserInfo',
        method: 'post',
        data
    })
}

export function getGoingCheckupProjectList(data) {
    return request({
        url: 'Evaluation/CheckupProject/getGoingCheckupProjectList',
        method: 'post',
        data
    })
}

export function getFinishCheckupProjectList(data) {
    return request({
        url: 'Evaluation/CheckupProject/getFinishCheckupProjectList',
        method: 'post',
        data
    })
}

export function operateCheckupProjectStatus(data) {
    return request({
        url: 'Checkup/CheckupProject/operateCheckupProjectStatus',
        method: 'post',
        data
    })
}

export function getCheckupProjectFileCategoryList() {
    return request({
        url: 'Checkup/CheckupFile/getCheckupProjectFileCategoryList',
        method: 'post',
    })
}

export function saveCheckupProjectFileCategoryInfo(data) {
    return request({
        url: 'Checkup/CheckupFile/saveCheckupProjectFileCategoryInfo',
        method: 'post',
        data
    })
}

export function deleteCheckupProjectFileCategoryInfo(data) {
    return request({
        url: 'Checkup/CheckupFile/deleteCheckupProjectFileCategoryInfo',
        method: 'post',
        data
    })
}

export function deleteCheckupProjectInfo(data) {
    return request({
        url: 'Checkup/CheckupProject/deleteCheckupProjectInfo',
        method: 'post',
        data
    })
}

export function editCheckupProjectInfo(data) {
    return request({
        url: 'Checkup/CheckupProject/editCheckupProjectInfo',
        method: 'post',
        data
    })
}

export function saveCheckupProjectFileInfo(data) {
    return request({
        url: 'Checkup/CheckupFile/saveCheckupProjectFileInfo',
        method: 'post',
        data
    })
}

export function getCheckupProjectFileList(data) {
    return request({
        url: 'Checkup/CheckupFile/getCheckupProjectFileList',
        method: 'post',
        data
    })
}

export function deleteCheckupProjectFileInfo(data) {
    return request({
        url: 'Checkup/CheckupFile/deleteCheckupProjectFileInfo',
        method: 'post',
        data
    })
}

export function getCheckupSubjectListInProject(data) {
    return request({
        url: 'Checkup/CheckupSubject/getCheckupSubjectListInProject',
        method: 'post',
        data
    })
}

export function saveCheckupItemExpertInfo(data) {
    return request({
        url: 'Checkup/CheckupSubject/saveCheckupItemExpertInfo',
        method: 'post',
        data
    })
}

export function getCheckupSubjectInProjectList() {
    return request({
        url: 'Checkup/CheckupProject/getCheckupSubjectInProjectList',
        method: 'post',

    })
}

export function saveCheckupSubjectWeightCoefficient(data) {
    return request({
        url: 'Checkup/CheckupSubject/saveCheckupSubjectWeightCoefficient',
        method: 'post',
        data
    })
}

export function getCheckupSubjectHistoryListInProjectList(data) {
    return request({
        url: 'Checkup/CheckupSubject/getCheckupSubjectHistoryListInProjectList',
        method: 'post',
        data
    })
}


export function getAllCheckupSubjectItemListByPrjectId(data) {
    return request({
        url: 'Checkup/CheckupProject/getAllCheckupSubjectItemListByPrjectId',
        method: 'post',
        data
    })
}


export function saveCheckupSubjectItemEvaluationInfo(data) {
    return request({
        url: 'Evaluation/CheckupProject/saveCheckupSubjectItemEvaluationInfo',
        method: 'post',
        data
    })
}

export function getCheckupCategoryTreeList() {
    return request({
        url: 'Base/Base/getCheckupCategoryTreeList',
        method: 'post'
    })
}

export function generateWordDecumentsForProjectReports(data) {
  return request({
    url: 'Checkup/CheckupProject/generateWordDecumentsForProjectReports',
    method: 'post',
    data
  })
}

export function saveCheckItemScore(data) {
  return request({
      url: 'Checkup/CheckupSubject/saveCheckItemScore',
      method: 'post',
      data
  })
}

export function checkItemEvaluationDel(data) {
  return request({
      url: 'Checkup/CheckupSubject/checkItemEvaluationDel',
      method: 'post',
      data
  })
}


// WEBPACK FOOTER //
// ./src/apis/projects.js